export const DEFAULT_SPRAYS = 2; // used for a product the user adds by hand
export const DEFAULT_SHORTFALL = 0.03; // used when the server has no bundle for the crop
export const DEFAULT_PACK_MODE = "auto"; // how partner boxes are chosen when a product has two pack sizes

export const PACK_OPTIONS = [
  { label: "Auto (groot en klein)", value: "auto" },
  { label: "Groot (net grootste pak)", value: "large" },
];
